import { DEFAULT_EXCEL_HEADER } from "./constants";
import { reindexRows, rowFromExcelArray } from "./rowUtils";

function isHeaderRow(row) {
  if (!Array.isArray(row) || row.length < 2) return false;
  const first = String(row[0] ?? "").trim();
  const second = String(row[1] ?? "").trim();
  return (
    first === DEFAULT_EXCEL_HEADER[0] ||
    second === DEFAULT_EXCEL_HEADER[1] ||
    second === "근무지"
  );
}

export function parseExcelMatrix(matrix) {
  if (!Array.isArray(matrix) || matrix.length === 0) return [];
  const startIdx = isHeaderRow(matrix[0]) ? 1 : 0;
  const rows = matrix
    .slice(startIdx)
    .map((arr, i) => rowFromExcelArray(arr, i + 1))
    .filter((row) =>
      [
        row.workplace,
        row.pname,
        row.porg,
        row.pphone,
        row.dutyDesc,
      ].some((v) => String(v || "").trim()),
    );
  return reindexRows(rows);
}
